export const ElementNotFound = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="flex flex-col items-center bg-white p-8 rounded-md">
        <p className="text-xl font-bold my-4">データが見つかりませんでした</p>
      </div>
    </div>
  );
};
